/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'project-panel.generic-error.description': 'Проверьте подключение к Интернету и повторите попытку.',
  'project-panel.generic-error.title': 'Произошла ошибка',
  'project-panel.project-icon-header.update-error-description': 'Не удалось обновить значок проекта «{projectName}»',
  'project-panel.project-icon-header.update-error-title': 'Произошла ошибка.',
  'project-panel.project-panel-expand-field-button.show-less-collapsed-label': 'Показать больше полей',
  'project-panel.project-panel-expand-field-button.show-more-collapsed-label': 'Свернуть',
  'project-panel.project-panel-header.title': 'Проект',
  'project-panel.project-panel-tabs.about-tab-title': 'Сведения',
  'project-panel.project-panel-tabs.decisions-title': 'Решения',
  'project-panel.project-panel-tabs.learnings-title': 'Выводы',
  'project-panel.project-panel-tabs.risks-title': 'Риски',
  'project-panel.project-panel-tabs.updates-tab-title': 'Обновления',
  'project-panel.project-title.edit-button-label': 'Изменить название проекта',
  'project-panel.project-title.update-error-description': 'Не удалось обновить содержимое для проекта «{projectName}»',
  'project-panel.project-title.update-error-title': 'Произошла ошибка',
  'project-panel.project-title.validation-message': 'Укажите название проекта',
};
